import React, { useState } from 'react';
import SEO from '../components/SEO';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs: FAQItem[] = [
    {
      question: 'Qu\'est-ce que BetSprinto ?',
      answer:
        'BetSprinto est un site indépendant qui compare et analyse les meilleures offres de paris sportifs en France. Nous fournissons des avis détaillés, des comparaisons et des guides pour vous aider à choisir le meilleur bookmaker selon vos besoins.',
    },
    {
      question: 'Les bookmakers présentés sont-ils sûrs ?',
      answer:
        'Oui, tous les bookmakers que nous présentons sont licenciés par l\'Autorité Nationale des Jeux (ANJ) et respectent les normes strictes de sécurité et de protection des joueurs en vigueur en France.',
    },
    {
      question: 'Comment choisir le meilleur bookmaker ?',
      answer:
        'Le meilleur bookmaker dépend de vos préférences : cotes, bonus, fonctionnalités, interface, etc. Utilisez notre outil de comparaison pour identifier celui qui correspond le mieux à vos besoins. Consultez nos avis détaillés pour chaque plateforme.',
    },
    {
      question: 'Les bonus sont-ils vraiment gratuits ?',
      answer:
        'Les bonus de bienvenue sont offerts lors de votre premier dépôt, mais ils sont soumis à des conditions de mise (rollover). Il faut généralement parier le montant du bonus plusieurs fois avant de pouvoir retirer les gains. Lisez toujours les conditions générales.',
    },
    {
      question: 'Combien de temps faut-il pour retirer mes gains ?',
      answer:
        'Les délais de retrait varient selon les bookmakers, généralement entre 24 et 48 heures. Certains proposent des retraits express en moins de 24h. Consultez notre comparaison pour voir les délais de chaque plateforme.',
    },
    {
      question: 'Puis-je utiliser plusieurs comptes sur différents bookmakers ?',
      answer:
        'Oui, vous pouvez avoir des comptes sur plusieurs bookmakers. Cela vous permet de comparer les cotes et de choisir la meilleure pour chaque pari. C\'est une stratégie courante chez les parieurs expérimentés.',
    },
    {
      question: 'Comment fonctionne le cashback ?',
      answer:
        'Le cashback est un pourcentage de vos pertes qui vous est remboursé, généralement sous forme de bonus ou d\'argent réel. Les conditions varient selon les bookmakers. Consultez les détails de chaque offre sur notre site.',
    },
    {
      question: 'Que faire en cas de problème avec un bookmaker ?',
      answer:
        'Si vous rencontrez un problème, contactez d\'abord le service client du bookmaker. Si le problème persiste, vous pouvez contacter l\'ANJ (Autorité Nationale des Jeux) qui régule les paris en ligne en France.',
    },
    {
      question: 'Les paris sportifs sont-ils légaux en France ?',
      answer:
        'Oui, les paris sportifs en ligne sont légaux en France depuis 2010. Ils sont régulés par l\'ANJ. Seuls les bookmakers licenciés par l\'ANJ peuvent opérer légalement en France.',
    },
    {
      question: 'Comment puis-je jouer de manière responsable ?',
      answer:
        'Fixez-vous des limites de dépôt et de temps de jeu. Ne pariez jamais plus que ce que vous pouvez vous permettre de perdre. Si vous pensez avoir un problème, contactez des organisations d\'aide comme Joueurs Info Service (09 74 75 13 13).',
    },
  ];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <SEO
        title="FAQ - Questions Fréquentes sur les Paris Sportifs"
        description="Réponses aux questions les plus fréquentes sur les paris sportifs en France, les bookmakers, les bonus et le jeu responsable."
        jsonLd={jsonLd}
      />

      <div className="min-h-screen pt-28 py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-4">
            Questions <span className="text-gradient">Fréquentes</span>
          </h1>
          <p className="text-gray-400 text-center mb-12">
            Trouvez des réponses aux questions les plus courantes sur les paris sportifs en France
          </p>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="glass rounded-xl overflow-hidden">
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full p-6 flex items-center justify-between text-left hover:bg-dark-hover transition-colors"
                >
                  <span className="text-white font-semibold text-lg pr-4">{faq.question}</span>
                  {openIndex === index ? (
                    <FaChevronUp className="text-accent-primary flex-shrink-0" />
                  ) : (
                    <FaChevronDown className="text-gray-400 flex-shrink-0" />
                  )}
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-6 text-gray-300 leading-relaxed animate-fade-in">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Contact CTA */}
          <div className="mt-12 glass rounded-xl p-8 text-center">
            <h2 className="text-2xl font-bold text-white mb-4">Une autre question ?</h2>
            <p className="text-gray-300 mb-6">
              Si vous ne trouvez pas la réponse à votre question, n'hésitez pas à nous contacter.
            </p>
            <a
              href="mailto:contact@betsprinto.com"
              className="inline-block bg-accent-primary hover:bg-accent-primary/90 text-white font-semibold py-3 px-6 rounded-lg transition-all"
            >
              Nous contacter
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;

